import React, { useContext, useEffect, useState } from 'react';
import Alerta from "../modal/Alerta";
import loader from "../../img/ajax-loader.gif";
import AuthContext from '../../context/authentication/authContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import {Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Modal, Button, Tooltip } from '@material-ui/core';
import {EventAvailable, EventBusy, Info, ImportExport, Autorenew} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    modal: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        borderRadius: 10,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    icono:{
        cursor: 'pointer'
    },
    active:{
        color: 'darkblue'
    },
    inactive:{
        color: 'crimson'
    }
}));

function Perfil() {

    const authToken = useContext(AuthContext);
    const { user, msg, editarUsuario } = authToken;

    const evaluationContext = useContext(EvaluationContext);
    const { formularios, consultarFormularios, activarCuestionario } = evaluationContext;

    useEffect(() => {
        consultarFormularios()
        if ( msg ) {
            setMessage(msg.msg);
        }
        // eslint-disable-next-line
    }, [msg])

    const styles = useStyles();

    const [ usr, setUser ] = useState({
        name: user.name,
        last_name: user.last_name,
        password: '',
        confirm_password: ''
    })

    const { name, last_name, password, confirm_password } = usr;

    const [ showAlerta, setShowAlerta] = useState(false);
    // eslint-disable-next-line
    const [ message, setMessage ] = useState("");
    const [ tempForm, setTempForm ] = useState({});
    const [ modalPreguntas, setModalPreguntas ] = useState(false);
    const [ tempChange, setTempChange ] = useState('');
    const [ waiting, setWaiting ] = useState(false);

    const perfiles = new Map();
    perfiles.set("Student", "Estudiante");
    perfiles.set("Teacher", "Mentor");

    const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const onChange = e => {
        setUser({
            ...usr,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = e => {
        e.preventDefault();

        // Passwords Iguales
        if ( name.trim() === '' || last_name.trim === '' || password.trim() === '' || confirm_password === '' ) {
            setMessage("❗ Por favor introduzca todos los datos");
            setShowAlerta(true);
            return;
        }
        if ( password !== confirm_password ) {
            setMessage("❗ No coinciden las contraseñas introducidas");
            setShowAlerta(true);
            document.getElementById("confirm_password").focus()
            return;
        }

        setMessage(<label><img src={loader} alt="loader" /> Procesando...</label>)
        setShowAlerta(true)
        
        editarUsuario(usr).then(setShowAlerta(true));
    }

    const bodyFormularioPreguntas=(
        <div className={styles.modal} >
            <h4>{tempForm?.title}</h4>
            <div><p>Evaluación de la reunión {capitalize(tempForm?.meeting)}, dirigida al perfil {perfiles.get(tempForm?.profile)}</p></div>
            <div>
                <h5>Cuestionario que se muestra al usuario</h5>   
                { tempForm?.questions?.map((item, index) => {
                        return(
                            <p key={index} dangerouslySetInnerHTML={{__html: item.q}}></p>
                        );
                    })
                }
            </div>
            <div align="right">
                <Button onClick={()=>abrirCerrarModalPreguntas()}>Cerrar</Button>
            </div>
        </div>
    )

    const revisarPreguntas=(data)=>{
        setTempForm(data);
        abrirCerrarModalPreguntas();
    }

    const abrirCerrarModalPreguntas=()=>{
        setModalPreguntas(!modalPreguntas);
    }

    const cambiarEstatus=(data)=>{
        setTempChange(data._id);
        setWaiting(true);
        activarCuestionario(data).then(reiniciarEstatus());
    }

    const reiniciarEstatus=()=>{
        setTempChange('');
        setWaiting(false);
    }

    return (
        <>
            <div className="container">
                { showAlerta && <Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={message} /> }
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-small">
                            <div className="card-header border-bottom">
                                <h5 className="m-0">Edicion de Perfil</h5>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item p-3">
                                <div className="row">
                                    <div className="col">
                                        <form onSubmit={onSubmit}>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="feFirstName">Nombre</label>
                                                    <input type="text" className="form-control" name="name" id="name" placeholder="Nombre" value={name} onChange={onChange} />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="feLastName">Apellido</label>
                                                    <input 
                                                        type="text" className="form-control" name="last_name" 
                                                        id="last_ame" placeholder="Apellido" 
                                                        value={last_name} 
                                                        onChange={onChange} />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="fePassword">Password</label>
                                                    <input 
                                                        type="password" className="form-control" name="password" 
                                                        id="password" placeholder="Password" minLength="6" 
                                                        value={password} onChange={onChange} />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="fePassword">Confirme Password</label>
                                                        <input type="password" className="form-control" name="confirm_password" id="confirm_password" placeholder="Confirme Password" 
                                                        minLength="6"
                                                        value={confirm_password} onChange={onChange} />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn btn-accent">Actualizar Datos</button>
                                        </form>
                                    </div>
                                </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <br/>

                { formularios && (
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-small">
                            <div className="card-header border-bottom">
                                <h5 className="m-0">Liberación de Evaluaciones de reuniones Mentor / Alumno</h5>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item p-3">
                                    <div className="row">
                                        <div className="col">
                                            <p>En la siguiente lista se encuentran los formularios de las evaluaciones, los cuáles son presentados de manera dinámica a los usuarios, por ejemplo, a un alumno o mentor sólo le será mostrada la evaluación que se encuentre activa para su perfil, para de esta forma, sólo tenga acceso a ese formulario y no adelantarlo a eventos futuros como conocer sobre temas o situaciones que se presentarán en el futuro de la mentoría.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <TableContainer >
                                                <Table>
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Título</TableCell>
                                                        <TableCell>Perfil</TableCell>
                                                        <TableCell>Meeting</TableCell>
                                                        <TableCell>Activo</TableCell>
                                                        <TableCell>Acciones</TableCell>
                                                    </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                    { formularios?.map((row) => {
                                                            return (
                                                                <TableRow key={row._id}>
                                                                    <TableCell>{row.title}</TableCell>
                                                                    <TableCell>{perfiles.get(row.profile)}</TableCell>
                                                                    <TableCell>{capitalize(row.meeting)}</TableCell>
                                                                    <TableCell align="center">{ row.active === true ? (
                                                                        <Tooltip title="Activo">
                                                                            <EventAvailable className={styles.active} />
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip title="Inactivo">
                                                                            <EventBusy className={styles.inactive} />
                                                                        </Tooltip>
                                                                    )}</TableCell>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Ver Formulario">
                                                                            <Info className={styles.icono} onClick={()=>revisarPreguntas(row)} />
                                                                        </Tooltip>&nbsp;&nbsp;&nbsp;
                                                                        
                                                                            { tempChange === row._id && waiting ? (
                                                                                <><Tooltip title="Cambiando estatus"><Autorenew className="waiting" /></Tooltip></>
                                                                            ) : (
                                                                                <><Tooltip title="Cambiar estatus"><ImportExport className={styles.icono} onClick={()=>cambiarEstatus(row)} /></Tooltip></>
                                                                            )}
                                                                            
                                                                        
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })
                                                    }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <br/><br/><br/><br/>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                )}
            </div>

            <Modal
                open={modalPreguntas}
                onClose={abrirCerrarModalPreguntas} >
                    {bodyFormularioPreguntas}
            </Modal>
        </>
    )
}

export default Perfil